import { Client } from "./Client";

/**
 * Service para configurações do Source Pathway (grupos, perfis, áreas urbanas, unidades).
 * Endpoints: /api/v1/source-config/{facilityId}/...
 */
export class SourceConfigService {
  constructor(private client: Client) {}

  private base(facilityId: string) {
    return `/source-config/${facilityId}`;
  }

  // ═══ GROUPS ═══

  async getGroups(facilityId: string) {
    const { data } = await this.client.api.get(`${this.base(facilityId)}/groups/`);
    return data;
  }

  async createGroup(facilityId: string, payload: { name: string; pollutant: string; color?: string; source_ids?: string[] }) {
    const { data } = await this.client.api.post(`${this.base(facilityId)}/groups/`, payload);
    return data;
  }

  async updateGroup(facilityId: string, groupId: string, payload: { name?: string; pollutant?: string; color?: string; source_ids?: string[] }) {
    const { data } = await this.client.api.put(`${this.base(facilityId)}/groups/${groupId}/`, payload);
    return data;
  }

  async deleteGroup(facilityId: string, groupId: string) {
    await this.client.api.delete(`${this.base(facilityId)}/groups/${groupId}/`);
  }

  // ═══ EMISSION PROFILES ═══

  async getProfiles(facilityId: string, sourceId?: string) {
    const params = sourceId ? `?source_id=${sourceId}` : "";
    const { data } = await this.client.api.get(`${this.base(facilityId)}/profiles/${params}`);
    return data;
  }

  async createProfile(facilityId: string, payload: { source_id: string; profile_type: string; reference_year: number; factors: number[]; description?: string }) {
    const { data } = await this.client.api.post(`${this.base(facilityId)}/profiles/`, payload);
    return data;
  }

  async deleteProfile(facilityId: string, profileId: string) {
    await this.client.api.delete(`${this.base(facilityId)}/profiles/${profileId}/`);
  }

  // ═══ URBAN AREAS ═══

  async getUrbanAreas(facilityId: string) {
    const { data } = await this.client.api.get(`${this.base(facilityId)}/urban-areas/`);
    return data;
  }

  async createUrbanArea(facilityId: string, payload: { name: string; population: number; enabled?: boolean }) {
    const { data } = await this.client.api.post(`${this.base(facilityId)}/urban-areas/`, payload);
    return data;
  }

  async updateUrbanArea(facilityId: string, areaId: string, payload: { name?: string; population?: number; enabled?: boolean }) {
    const { data } = await this.client.api.put(`${this.base(facilityId)}/urban-areas/${areaId}/`, payload);
    return data;
  }

  async deleteUrbanArea(facilityId: string, areaId: string) {
    await this.client.api.delete(`${this.base(facilityId)}/urban-areas/${areaId}/`);
  }

  // ═══ UNITS CONFIG ═══

  async getUnits(facilityId: string) {
    const { data } = await this.client.api.get(`${this.base(facilityId)}/units/`);
    return data;
  }

  async updateUnits(facilityId: string, payload: { emission_unit?: string; output_unit?: string }) {
    const { data } = await this.client.api.put(`${this.base(facilityId)}/units/`, payload);
    return data;
  }
}
